import { useEffect, useState } from 'react'

/**
 * Returns a stable object URL for the given Blob/File and revokes it when the blob changes or the component unmounts.
 * Calling URL.createObjectURL in render creates (and leaks) a new URL on every render.
 */
export function useObjectUrl(blob?: Blob): string | undefined {
  const [url, setUrl] = useState<string>()

  useEffect(() => {
    if (!blob) {
      setUrl(undefined)
      return
    }

    const objectUrl = URL.createObjectURL(blob)
    setUrl(objectUrl)
    return () => URL.revokeObjectURL(objectUrl)
  }, [blob])

  return url
}

export default useObjectUrl
